import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { ButtonTertiary, Type, screenXsMin, spacer16, spacer40 } from '@spotify-internal/encore-web';
import { useTracking } from '../../Tracking';
import { HELP_LIST_TRACK_CAT, hidden } from '../../Help/util';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var InfoHelpful = styled.div.withConfig({
  displayName: "ArticleFeedbackModule__InfoHelpful",
  componentId: "pc394q-0"
})(["padding:", " 0;"], spacer40);
var Divider = styled.hr.withConfig({
  displayName: "ArticleFeedbackModule__Divider",
  componentId: "pc394q-1"
})(["border:1px solid ", ";@media (max-width:", "){", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, screenXsMin, hidden);
var CTAButton = styled(ButtonTertiary).withConfig({
  displayName: "ArticleFeedbackModule__CTAButton",
  componentId: "pc394q-2"
})(["margin-right:", ";color:", ";border:", ";&:hover:not(:focus):not(:disabled),&:active:not(:disabled),&:focus:not(:disabled),&.highlight{color:", ";background-color:", ";}"], spacer16, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.box.text, " 1px solid");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.box.background;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.box.text;
});
var Message = styled(Type.h4).attrs({
  variant: Type.heading4
}).withConfig({
  displayName: "ArticleFeedbackModule__Message",
  componentId: "pc394q-3"
})(["text-align:left;padding-bottom:", ";"], spacer16);
var Buttons = styled.div.withConfig({
  displayName: "ArticleFeedbackModule__Buttons",
  componentId: "pc394q-4"
})([""]);
export var ArticleFeedbackModule = function ArticleFeedbackModule() {
  var _useTracking = useTracking(),
      eventHandler = _useTracking.eventHandler;

  var _useState = useState(false),
      feedbackReceived = _useState[0],
      setFeedbackReceived = _useState[1];

  var t = useT();
  var router = useRouter();
  var path = router.asPath;
  useEffect(function () {
    setFeedbackReceived(false);
  }, [router.asPath]);
  return /*#__PURE__*/_jsxs(InfoHelpful, {
    children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Message, {
      children: t('FRODOR_377c48', 'Was this information helpful?', '')
    }), !feedbackReceived ? /*#__PURE__*/_jsxs(Buttons, {
      children: [/*#__PURE__*/_jsx(CTAButton, {
        onClick: function onClick(e) {
          setFeedbackReceived(true);
          eventHandler(HELP_LIST_TRACK_CAT, "".concat(path, " InfoHelpful - Yes"))(e);
        },
        children: t('FRODOR_b00cc1', 'Yes', '')
      }), /*#__PURE__*/_jsx(CTAButton, {
        onClick: function onClick(e) {
          setFeedbackReceived(true);
          eventHandler(HELP_LIST_TRACK_CAT, "".concat(path, " InfoHelpful - No"))(e);
        },
        children: t('FRODOR_c265e7', 'No', '')
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: t('FRODOR_6fb6f2', 'Thank you for your feedback!', '')
    })]
  });
};